module.exports = __webpack_public_path__ + "img/android.18f0bac0.png";